import { mergeAttributes } from '@tiptap/core';
import Heading from '@tiptap/extension-heading';

const headings: Record<number, string> = {
  1: 'text-display-large',
  2: 'text-display-medium',
  3: 'text-display-small',
  4: 'text-headline-large',
  5: 'text-headline-medium',
  6: 'text-headline-small',
};

export const CustomHeading = Heading.extend({
  parseHTML() {
    // Headings are saved as styled divs (see renderHTML), so read those back as
    // headings too, otherwise they turn into paragraphs when the text is edited again.
    return [
      ...(this.parent?.() ?? []),
      ...Object.entries(headings).map(([level, headingClass]) => ({
        tag: `div.${headingClass}`,
        attrs: {
          level: Number(level),
        },
      })),
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    const level: number = node.attrs.level;
    const headingClass = headings[level] || 'text-headline-small';
    return [
      `div`,
      mergeAttributes(
        this.options.HTMLAttributes,
        HTMLAttributes,
        { class: headingClass },
      ),
      0,
    ];
  },
});
